module.exports = __webpack_public_path__ + "img/france-genitourinary-diseases-female.c4596efe.png";